
export interface IDomain {
  id: number;
  key: string;
  domain: string;
  kingdom?: string;
  reject: number[];
  groupID?: number;
}

export class CDomain implements IDomain {
  public key = '';
  public id = 0;
  public reject = [];
  public domain = '';
}

export interface IValues {
  setData: string;
  date: string;
  datefrom?: string;
  dateto?: string;
  compareSetData?: string;
  bannedApps?: IBannedAppValue[];
  weekFirst?: string;
  cutoffDay?: string;
  startdate?: string;
}

export interface IBannedAppValue {
  name: string;
  appChecked: boolean;
  winChecked: boolean;
}

export class CValues implements IValues {
  public setData = '';
  public date = '';
}

export interface IData {
  now: object;
  graph: IDomain[];
  groups: IDomain[];
  materials: IDomain[];
  values: IValues;
  groupID?: number;
}

export class CData implements IData {
  public now = {};
  public graph = [] as IDomain[];
  public groups = [] as IDomain[];
  public materials = [] as IDomain[];
  public values = new CValues();
}

// ヒートマップの１セル分のデータ。
export interface IHeatmapCellData {
  value: number; // 値
}

/**
 * グラフデータ１列分のデータ。
 */
export interface IGraphData {
  label: string;
  workTime?: string;
  overTime?: string;
  fixedTime?: string;
  intervalTime?: string;
  count?: string;
  pcStartTime?: string;
  pcEndTime?: string;
  pcTime?: string;
  appLabels?: string[];
  apps?: IDataSeries[]; // valの要素はappLabelsに対応
  userLabels?: string[];
  users?: IDataSeries[]; // valの要素はuserLabelsに対応
  user_ids?: string;
  compareValue?: IGraphData;
  day?: IDataSeries[];
  month?: IDataSeries[];
  months?: string;
  year?: IDataSeries[];
  heatmapLineCells?: IHeatmapCellData[];   // ヒートマップの１列分のデータ。
  heatmapColorbarValueMax?: number;  // ヒートマップのカラーバーの最大値。列ごとにデータを付与する必要はないが、受け渡す方法がここしかないので、無駄な送信になってしまうがここに追加する。
}

export interface IDataSeries {
  lbl: string;  // label
  val: string[];  // value
  innerSeries?: IDataSeries[];

  departmentId?: any;
  departmentName?: any;
  isDataSeries?: any;
}

export class CGraphData implements IGraphData {
  public label = '';
  // public workTime = '';
  // public overTime = '';
  // public fixedTime = '';
}

export interface IOptionValue {
  key: string;
  value: any;
}

export interface ITooltip {
  tooltipModel: any;
  position: any;
  ratio: number;
}

export interface ILegend {
  index: number;
  bgcolor: string;
  value: string;
  hidden: boolean;
}
